module.exports = __webpack_public_path__ + "img/introducePageFour_show_one.f1b00af5.jpg";